// Automatically generated from TW.Saga.Core.Base, Version=1.0.0.0, Culture=neutral, PublicKeyToken=null @15.06.2017 16:59:16
import { GetResourceListRequest_abstract } from './../abstract/SagaBase/GetResourceListRequest_abstract';
export class GetResourceListRequest extends GetResourceListRequest_abstract {}
